<template>
      <div class="mi-div">
       <p class="d-flex justify-content-center py-5" style="color:#87a8a7">{{name_}}</p>
       <i v-if="!fingerprint_" class="fa fa-fingerprint fa-5x d-flex justify-content-center" style="color:#87a8a7"></i>
       <div v-else class="d-flex justify-content-center">
         <img  :src="'data:image/jpg;base64,'+fingerprint_" width="120" height="150" alt="">
       </div>
      </div>
</template>
<script>
import { defineComponent, ref, watchEffect, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "fingerPrint",
  props: {
    name: String,
    fingerprint: String
  },
  setup(props){
      const route = useRoute();
      const nombre= ref(null);
      const id=ref(null);
      const fingerprint_ =ref(null)
      watchEffect(() => {
        if (props.fingerprint) {
          fingerprint_.value = props.fingerprint
        }
      })
        return{
          name_: props.name,
          fingerprint_,
        }
    },
})
</script>
<style scoped>
.mi-div {
      margin: 5px;  /*Añade un margen de 20px en todos los lados del div */
      background-color: lightgray; /* Color de fondo del div */
      padding: 5px; /* Añade un relleno de 10px alrededor del contenido del div */
      margin-bottom: 10px;
      padding-bottom: 50px;

}
</style>